export const scrollToElement = (id: string) => {
  const errorLabel = document.querySelector(`label[for="${id}"]`);
  const errorElement = document.querySelector(`[id="${id}"]`);
  if (errorLabel && !isInViewport(errorLabel)) {
    if (errorLabel) {
      // When there is a label, scroll this label into view.
      setTimeout(() => scrollIntoView(errorLabel, true));
    }
  }
  if (
    (errorElement instanceof HTMLInputElement || errorElement instanceof HTMLTextAreaElement) &&
    !isCombobox(errorElement)
  ) {
    // When there is an input, give it focus.
    setTimeout(() => errorElement.focus(), 500);
  }
};

/**
 * True if the specified element is within the viewport, false otherwise.
 * See https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
 *
 * @param element the element to test
 */
export const isInViewport = (element: Element): boolean => {
  const rect = element.getBoundingClientRect();

  // TODO: handle overflow-scroll in element's container?
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      // innerHeight can in fact be undefined in some old browsers.
      (window.innerHeight ?? document.documentElement.clientHeight) &&
    // innerHeight can in fact be undefined in some old browsers.
    rect.right <= (window.innerWidth ?? document.documentElement.clientWidth)
  );
};

export const scrollIntoView = (element: Element, smoothScroll = false): void => {
  if (!smoothScroll || prefersReducedMotion()) {
    // Avoid passing anything to scrollIntoView() (when we can) to maximize browser compatibility.
    element.scrollIntoView();
  } else {
    try {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch {
      // If scrollIntoView with options throws, fall back on no options.
      // See https://github.com/frontarm/navi/issues/71
      element.scrollIntoView();
    }
  }
};

export const isCombobox = (element: HTMLElement): boolean => element.getAttribute('role') === 'combobox';

/**
 * True if the user prefers reduced motion, false otherwise.
 *
 * See https://css-tricks.com/introduction-reduced-motion-media-query/
 */
export const prefersReducedMotion = (): boolean => {
  // See https://caniuse.com/#feat=matchmedia
  return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
